import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";
import { Section } from "./components/section/section";
import SignIn from "./components/sign-in/first-step";
import { SectionsList } from "./components/sections-list";
import { SignInSecondStep } from "./components/sign-in/second-step";
import { UserProgramContextProvider } from "./context/user-program/user-program";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
// import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";
import {
  ROUTE_HOME,
  SUBROUTE_CLINIC_HOME,
  SUBROUTE_CLINIC_HOME_STUDOQ,
  SUBROUTE_HOME_SECTION,
  SUBROUTE_HOME_SECTION_ACUTY_CALENDAR,
  SUBROUTE_HOME_SECTION_DOCUMENTS,
  SUBROUTE_HOME_SECTION_VIDEOS,
  SUBROUTE_MAGIC_LINK,
  SUBROUTE_PATIENTS,
  SUBROUTE_PATIENTS_ADMIN,
  SUBROUTE_PATIENTS_DETAIL,
  SUBROUTE_SIGN_IN,
  SUBROUTE_SIGN_IN_SECOND_STEP,
  SUBROUTE_STUDOQ_TEST,
  SUBROUTE_CLINIC_PATIENTS,
  SUBROUTE_CLINIC_WEIGHT,
} from "./constants";
import { MagicLink } from "./components/sign-in/magic-link";
import { SectionContent } from "./components/section-content/section-content";
import { SectionDocuments } from "./components/section-documents/section-documents";
import { PageNotFound } from "./components/404";
import { SignInHomeRedirect } from "./components/shared/signin-home-redirect";
import { ProtectedRoute } from "./components/shared/protected-route";
import { EmployeeProtectedRoute } from "./components/shared/employee-protected-route";
import { Footer } from "./components/footer";
import { mmkTheme } from "./utils/theme";
import { SectionMonthlyTraining } from "./components/section-monthly-training";
import { SectionClients } from "./components/patient/patients";
import { TypeformModal } from "./components/typeform-modal";
import { DetailPatient } from "./components/patient/details-patient";
import { Dashboard } from "./components/patient/admin/dashboard";
import { AdminProtectedRoute } from "./components/shared/admin-protected-route";
import { ClinicProtectedRoute } from "./components/shared/clinic-protected-route";
import { ClinicDashboard } from "./components/clinic/clinic-dashboard";
import { ClinicPatients } from "./components/clinic/clinic-patients";
import { StudoqPage } from "./components/clinic/clinic-studoq";
import { StudoqTestPage } from "./components/clinic/clinic-studoq-test";
import { ClinicWeightProtectedRoute } from "./components/shared/clinic-weight-protected-route";
import { RolProtectedRoutePatients } from "./components/shared/rol-protected-route-patients";
import { ShopifyProduct } from "./components/patient/shopify-product";
import { MatomoProvider } from "./components/matomo-provider";

//TODO: Change this URL to the one of your Matomo instance for production
const URL_MATOMO = "https://adipositasgutachten-analytics.matomo.cloud/";
const SITE_ID = 4;

const router = createBrowserRouter([
  {
    path: ROUTE_HOME,
    element: (
      <ThemeProvider theme={mmkTheme}>
        <UserProgramContextProvider>
          <CssBaseline />
          <MatomoProvider url={URL_MATOMO} siteId={SITE_ID}>
            {" "}
            <Box display="flex" flexDirection="column" minHeight="100dvh">
              <Box flexGrow="1" position="relative">
                <Outlet />
              </Box>
              <TypeformModal />
              <Footer />
            </Box>
          </MatomoProvider>
        </UserProgramContextProvider>
      </ThemeProvider>
    ),
    children: [
      {
        index: true,
        path: "",
        element: (
          <ProtectedRoute>
            <SectionsList />
          </ProtectedRoute>
        ),
      },
      {
        path: "shop",
        element: <ShopifyProduct />,
      },
      {
        path: SUBROUTE_HOME_SECTION,
        element: (
          <ProtectedRoute>
            <Section />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute>
                <SectionContent />
              </ProtectedRoute>
            ),
          },
          {
            path: SUBROUTE_HOME_SECTION_VIDEOS,
            element: (
              <ProtectedRoute>
                <div>
                  {/* Temporarily commented out SectionContent to avoid showing video content until the questionaries come back */}
                  {/* <SectionContent /> */}
                </div>
              </ProtectedRoute>
            ),
          },
          {
            path: SUBROUTE_HOME_SECTION_DOCUMENTS,
            element: (
              <ProtectedRoute>
                <SectionDocuments />
              </ProtectedRoute>
            ),
          },
          {
            path: SUBROUTE_HOME_SECTION_ACUTY_CALENDAR,
            element: (
              <ProtectedRoute>
                <SectionMonthlyTraining />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: SUBROUTE_SIGN_IN,
        element: (
          <SignInHomeRedirect>
            <SignIn />
          </SignInHomeRedirect>
        ),
      },
      {
        path: SUBROUTE_SIGN_IN_SECOND_STEP,
        element: (
          <SignInHomeRedirect>
            <SignInSecondStep />
          </SignInHomeRedirect>
        ),
      },
      {
        path: SUBROUTE_MAGIC_LINK,
        element: (
          <SignInHomeRedirect>
            <MagicLink />
          </SignInHomeRedirect>
        ),
      },
      {
        path: SUBROUTE_PATIENTS,
        element: (
          <EmployeeProtectedRoute>
            <SectionClients />
          </EmployeeProtectedRoute>
        ),
      },

      {
        path: SUBROUTE_PATIENTS_DETAIL,
        element: (
          <RolProtectedRoutePatients>
            <DetailPatient />
          </RolProtectedRoutePatients>
        ),
      },
      {
        path: SUBROUTE_PATIENTS_ADMIN,
        element: (
          <AdminProtectedRoute>
            <Dashboard />
          </AdminProtectedRoute>
        ),
      },
      {
        path: SUBROUTE_CLINIC_HOME,
        element: (
          <ClinicProtectedRoute>
            <ClinicDashboard />,
          </ClinicProtectedRoute>
        ),
      },
      {
        path: SUBROUTE_CLINIC_HOME_STUDOQ,
        element: (
          <ClinicProtectedRoute>
            <StudoqPage />
          </ClinicProtectedRoute>
        ),
      },
      {
        path: SUBROUTE_CLINIC_PATIENTS,
        element: (
          <ClinicProtectedRoute>
            <ClinicPatients />
          </ClinicProtectedRoute>
        ),
      },
      {
        path: SUBROUTE_CLINIC_WEIGHT,
        element: (
          <ClinicWeightProtectedRoute>
            <ClinicPatients />
          </ClinicWeightProtectedRoute>
        ),
      },
      {
        path: SUBROUTE_STUDOQ_TEST,
        element: (
          <ClinicProtectedRoute>
            <StudoqTestPage />,
          </ClinicProtectedRoute>
        ),
      },
      {
        path: "patients/:patient",
        element: (
          <ClinicProtectedRoute>
            <DetailPatient />
          </ClinicProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
]);

const App = () => <RouterProvider router={router} />;

export default App;
